import React from 'react';
import CatItem from './CatItem';

export default function CategoriesList({ catArray, updateFilter, className }) {
  if (Array.isArray(catArray)) {
    return (
      <ul className={className}>
        {catArray.map((cat) => <CatItem key={cat.id} category={cat} updateFilter={updateFilter} />)}
      </ul>
    );
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/containers/Categories/components/CategoriesList/index.js